import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IBIN } from '../models/models'

export class EditBinNumberApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/card-bin/EditBinNumber',
      requesterInfo,
    })
  }

  public async EditBinNumber(BIN: IBIN): Promise<any> {
    return await this.postAsync<IBIN>(BIN)
  }
}
